<template>
	<div class="container-fluid mt-3">
		<div class="row">
			<div class="col-md-6 bg-grey p-5">
				<h4 class="text-uppercase font-basetheme font-kanit text-center">
					บริษัท เอ็มเมอรัลด์ เทค แอดวานซ์ จำกัด
					<br />EMERALD TECH ADVANCE CO., LTD.
				</h4>
				<div class="colunm-border-bottom pb-3 w-50 m-auto"></div>
				<div class="row mt-5">
					<div class="col-12 d-flex">
						<span class="py-2 px-3 bg-secondtheme font-2x font-white">
							<span class="mdi mdi-map-marker"></span>
						</span>
						<span class="ml-3">
							<span class="text-uppercase font-secondtheme font-kanit">Address</span>
							<br />ชั้น 4 เลขที่ 43 ซอยประเสริฐมนูกิจ 5 ถนนประเสริฐมนูกิจ แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพมหานคร 10230
						</span>
					</div>

					<div class="col-12 d-flex mt-3">
						<span class="py-2 px-3 bg-secondtheme font-2x font-white">
							<span class="mdi mdi-card-account-phone"></span>
						</span>
						<span class="ml-3">
							<span class="text-uppercase font-secondtheme font-kanit">Contact</span>
							<br />ชั้น 4 เลขที่ 43 ซอยประเสริฐมนูกิจ 5 ถนนประเสริฐมนูกิจ แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพมหานคร 10230
						</span>
					</div>

					<div class="col-12 d-flex mt-3">
						<span class="py-2 px-3 bg-secondtheme font-2x font-white">
							<span class="mdi mdi-phone"></span>
						</span>
						<span class="ml-3">
							<span class="text-uppercase font-secondtheme font-kanit">Phone</span>
							<br />02 570-5580 ต่อ 4111, 094 325 5424
						</span>
					</div>

					<div class="col-12 d-flex mt-3">
						<span class="py-2 px-3 bg-secondtheme font-2x font-white">
							<span class="mdi mdi-email-newsletter"></span>
						</span>
						<span class="ml-3">
							<span class="text-uppercase font-secondtheme font-kanit">EMAIL</span>
							<br />info@emeraldtech.co.th
						</span>
					</div>
				</div>
			</div>
			<div class="col-md-6 bg-bluegrey p-5">
				<h4 class="text-uppercase font-secondtheme font-kanit text-center">
					Contact Form
					<br />EMERALD TECH ADVANCE CO., LTD.
				</h4>
				<div class="colunm-border-bottom pb-3 w-50 m-auto"></div>

				<form class="mt-5">
					<div class="form-group">
						<input
							type="text"
							class="form-control rounded-0"
							id="inputAddress"
							placeholder="Your Name"
						/>
					</div>
					<div class="form-group">
						<input
							type="text"
							class="form-control rounded-0"
							id="inputAddress2"
							placeholder="Your Email"
						/>
					</div>
					<div class="form-group">
						<label for="inputAddress2"></label>
						<textarea
							name="message"
							id="message"
							class="form-control rounded-0"
							cols="30"
							rows="10"
							placeholder="Your Message"
						></textarea>
					</div>
					<button
						type="submit"
						class="btn bg-basetheme btn-block font-white"
					>SEND</button>
				</form>
			</div>
		</div>
		<div class="row">
			<div class="col-12 mt-5 bg-white p-5">

				<!-- 
					เปลี่ยนให้แล้วนะ
					<iframe
					src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3874.5225299897434!2d100.5569406!3d13.8076324!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29c446dd1c7ed%3A0x864a385c38bb4efe!2sRegus%20-%20Bangkok%2C%20SJ%20Infinite%20I%20Business%20Complex!5e0!3m2!1sth!2sth!4v1587372477614!5m2!1sth!2sth"
					width="100%"
					height="450"
					frameborder="0"
					style="border:0;"
					allowfullscreen
					aria-hidden="false"
					tabindex="0"
				></iframe> -->

				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3873.921247732899!2d100.59021661483152!3d13.843765590287973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29d15d5c631cb%3A0x3959dbac86075e62!2z4Lia4Lij4Li04Lip4Lix4LiXIOC4m-C4oOC4niDguIjguLPguIHguLHguJQ!5e0!3m2!1sth!2sth!4v1626797669611!5m2!1sth!2sth"
					width="100%"
					height="450"
					frameborder="0"
					style="border:0;"
					allowfullscreen
					aria-hidden="false"
					tabindex="0"
				></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	export default {};
</script>

<style>
</style>